import type { KeyValueConfig } from "@smartsuite/automation-engine-api";
import { valueConfigVToBool } from "@smartsuite/automation-conditions";

export const validateKeyValueInput = (keyValue: KeyValueConfig): boolean => {
  const keyValues = keyValue.key?.values ?? [];
  const valueValues = keyValue.value?.values ?? [];
  return [...keyValues, ...valueValues].every((value) => {
    try {
      if (
        value.value.oneofKind === "bool" ||
        value.value.oneofKind === "list"
      ) {
        return true;
      }
      if (value.value.oneofKind === "string" && value.value.string !== "") {
        return true;
      }
      return valueConfigVToBool(value);
    } catch (e) {
      return true;
    }
  });
};
